<template>
    <base-detail
      v-bind:title="$filters.localize('UserDetail.caption')"
      v-bind:rootId="rootId"
      v-bind:rootColumn="rootColumn"
      v-bind:schemaName="'user'"
      v-bind:headers="headers"
      v-bind:entity="entity"
      v-bind:lookups="lookups"
      v-on:main-save="main - save"
      v-on:on-parrent-load="on - parrent - load"
    >
        <template
          v-if="entity.contactId"
          v-slot="{ entity }"
          class="input-group"
        >
            <form
              v-on:submit.prevent="createUser"
              class="input-group mb-3 detail-add-form"
            >
              <div
                class="detail-add-form__field detail-add-form__login detail-add-form__field--floating"
                :class="{ 'detail-add-form__field--filled': !!entity.login }"
              >
                <label class="detail-add-form__label">{{
                  $filters.localize('login.login')
                }}</label>
                <input
                  class="form-control detail-add-form__control"
                  type="text"
                  v-model="entity.login"
                  required
                >
              </div>
              <div
                class="detail-add-form__field detail-add-form__password detail-add-form__field--floating"
                :class="{ 'detail-add-form__field--filled': !!entity.password }"
              >
                <label class="detail-add-form__label">{{
                  $filters.localize('login.password')
                }}</label>
                <input
                  class="form-control detail-add-form__control"
                  type="password"
                  v-model="entity.password"
                  required
                >
              </div>
              <div
                class="detail-add-form__field detail-add-form__role detail-add-form__field--floating"
                :class="{ 'detail-add-form__field--filled': !!entity.roleId }"
              >
                <label class="detail-add-form__label">{{
                  $filters.localize('tableColumns.user.role_name')
                }}</label>
                <select
                  class="form-control detail-add-form__control"
                  v-model="entity.roleId"
                  required
                >
                    <option
                      value=""
                      disabled
                    ></option>
                    <option
                      v-for="role in lookups.roles"
                      v-bind:key="role.id"
                      :value="role.id"
                    >
                        {{ role.name }}
                    </option>
                </select>
              </div>
              <button
                :disabled="!enabled"
                class="btn btn-primary detail-add-form__submit"
                type="submit"
              >{{ $filters.localize('button.add') }}</button>
            </form>
        </template>
    </base-detail>
</template>

<script>
import BaseDetail from '@/components/Sections/BaseDetail.vue';
export default {
    name: "UserDetail",
    components: { BaseDetail },
    emits: ["on-parrent-load", "main-save"],
    props: {
        rootId: { type: String, require: true },
        rootColumn: { type: String, require: true },
        enabled: { type: Boolean }
    },
    methods: {
        createUser() {
            this.$store.dispatch('createLogin', JSON.parse(JSON.stringify(this.entity)))
                .then(() => {
                    this.entity = {
                        login: "",
                        contactId: this.rootId,
                        password: "",
                        roleId: "",
                    };
                    this.$toast.success("Користувача успішно створено");
                })
                .catch(() =>
                    this.$toast.error("Логін вже існує"));
        },
        loadLookups() {
            this.$store.dispatch('section', { table: "role" })
                .then((response) => {
                    this.lookups.roles = response.data.data;
                });
        }
    },
    mounted() {
        this.loadLookups();
    },
    data() {
        return {
            lookups: {
                roles: []
            },
            entity: {
                login: "",
                contactId: this.rootId,
                password: "",
                roleId: "",
            },
            headers: [
                { field: "userName", name: this.$filters.localize('login.login'), sort: true },
                { field: "role.name", name: "Роль", sort: true },
                { field: "isActive", name: "Активний", sort: true, input: { type: "checkbox" }, enabeled: true },
                { field: "id", name: this.$filters.localize('button.action'), action: true }
            ]
        };
    }
}
</script>

<style scoped>
.detail-add-form {
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0;
  position: relative;
  z-index: 20;
  width: 100%;
}

.detail-add-form__field {
  flex: 1 1 0;
  min-width: 0;
  height: 36px;
  min-height: 36px;
  position: relative;
}

.detail-add-form__field + .detail-add-form__field,
.detail-add-form__submit {
  margin-left: -1px;
}

.detail-add-form__field:focus-within,
.detail-add-form__control:focus {
  z-index: 2;
}

.detail-add-form__label {
  margin: 0;
  color: #7b8794;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
}

.detail-add-form__field--floating .detail-add-form__label {
  position: absolute;
  top: 50%;
  left: 12px;
  z-index: 3;
  max-width: calc(100% - 24px);
  overflow: hidden;
  transform: translateY(-50%);
  transition: top 0.14s ease, transform 0.14s ease, font-size 0.14s ease, color 0.14s ease;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.detail-add-form__field--floating:focus-within .detail-add-form__label,
.detail-add-form__field--floating.detail-add-form__field--filled .detail-add-form__label {
  top: 6px;
  transform: none;
  color: #4f7fa7;
  font-size: 0.58rem;
  text-transform: uppercase;
}

.detail-add-form__control {
  width: 100%;
  height: 36px;
  min-height: 36px;
  border-color: #ced4da;
  border-radius: 0;
  position: relative;
}

.detail-add-form__field--floating .form-control.detail-add-form__control {
  padding: 14px 12px 2px;
}

.detail-add-form__field--floating:not(.detail-add-form__field--filled):not(:focus-within) .form-control.detail-add-form__control {
  color: transparent;
}

.detail-add-form__field--floating:not(.detail-add-form__field--filled):not(:focus-within) .form-control.detail-add-form__control option {
  color: #495057;
}

.detail-add-form__login,
.detail-add-form__password {
  min-width: 170px;
}

.detail-add-form__role {
  min-width: 150px;
}

.detail-add-form__login .detail-add-form__control {
  border-radius: 0.25rem 0 0 0.25rem;
}

.detail-add-form__submit {
  flex: 0 0 auto;
  height: 36px;
  min-height: 36px;
  padding-inline: 1rem;
  white-space: nowrap;
  border-radius: 0 0.25rem 0.25rem 0;
  position: relative;
  z-index: 1;
}

@media (max-width: 576px) {
  .detail-add-form {
    gap: 0.5rem;
  }

  .detail-add-form__field,
  .detail-add-form__submit,
  .detail-add-form__control {
    flex-basis: 100%;
    width: 100%;
    margin-left: 0;
    border-radius: 0.25rem;
  }
}
</style>
